/**
 * Zentrale Zahlen-/Währungsformatierung — immer deutsches Format
 * (1.234,56 €), unabhängig von Browser-Locale / ICU-Daten.
 */
const SYMBOLS = { EUR: "€", USD: "$", GBP: "£", CHF: "CHF" };

// 1.234,56
export function deNumber(n, decimals = 2) {
  const num = Number(n) || 0;
  const [int, frac] = Math.abs(num).toFixed(decimals).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return (num < 0 ? "-" : "") + grouped + (frac ? `,${frac}` : "");
}

// 1.234,56 €
export function deCurrency(n, cur = "EUR", decimals = 2) {
  const code = (cur || "EUR").toUpperCase();
  return `${deNumber(n, decimals)} ${SYMBOLS[code] || code}`;
}
